import { gql } from '@common/hooks';

export const UpdateWorksMembershipPermissions = gql`
  mutation UpdateMembershipPermissions(
    $input: UpdateMembershipPermissionInput!
  ) {
    updateMembershipPermissions(input: $input) {
      success
    }
  }
`;
